import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, map, mergeMap } from 'rxjs/operators';
import { LanguageService } from '../../language.service';

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {
  private messageSubject: Subject<any> = new Subject();
  public messageString: Observable<string[]>;

  constructor(
    private languageService: LanguageService,
    private translateService: TranslateService,
  ) { }

  public getToasterTranslation<K extends string[]>(...type: K[]): Observable<string[]> {
    return this.languageService.currentLanguage
      .pipe(
        distinctUntilChanged(),
        map(res => {
          let object: Observable<string[] | null>
          type.forEach(arg => {
            object = this.translateService.get(arg)
          })
          return object
        }),
        mergeMap(message => {
          this.messageSubject.next(message)
          return message
        })
      )
  }
}
